import React, { OlHTMLAttributes } from 'react';
import { BLOCKS } from '@contentful/rich-text-types';

import { ILegalPageSectionFields } from '../../../types/contentful';

import { BlockContainer, Column, Layout } from '../Layout';
import RichText from '../RichText';
import { UnorderedListNode } from '../RichText/Nodes';

import {
  StyledOrderedList as OrderedList,
  StyledUnorderedList as UnorderedList
} from './styles';

export enum orderListTypeEnum {
  uppercaseLetters = 'Uppercase Letters',
  lowercaseLetters = 'Lowercase Letters',
  uppercaseRomanNumerals = 'Uppercase Roman Numerals',
  lowercaseRomanNumerals = 'Lowercase Roman Numerals',
  numbers = 'Numbers',
  greenCaret = 'Green Caret'
}

export const orderedListTypeMapping: {
  [key in orderListTypeEnum]: OlHTMLAttributes<string>['type'];
} = {
  [orderListTypeEnum.uppercaseLetters]: 'A',
  [orderListTypeEnum.lowercaseLetters]: 'a',
  [orderListTypeEnum.uppercaseRomanNumerals]: 'I',
  [orderListTypeEnum.lowercaseRomanNumerals]: 'i',
  [orderListTypeEnum.numbers]: '1',
  [orderListTypeEnum.greenCaret]: undefined
};

export function LegalPageSection({
  sectionId,
  content,
  orderedListStartsAt,
  orderedListType
}: ILegalPageSectionFields) {
  const orderedListTypeIndex =
    (orderedListType as orderListTypeEnum) ?? orderListTypeEnum.numbers;

  return (
    <div id={sectionId!}>
      <BlockContainer
        data-blockid="legal-page-section"
        data-testid="legal-page-section"
      >
        <Layout>
          <Column size={{ 0: 10, tablet: 8 }} flexDirection="column">
            <RichText
              overrideOptions={{
                [BLOCKS.UL_LIST]: (node, children) =>
                  orderedListType === orderListTypeEnum.greenCaret ? (
                    <UnorderedListNode node={node} bulletColor="green">
                      {children}
                    </UnorderedListNode>
                  ) : (
                    <UnorderedList>{children}</UnorderedList>
                  ),
                [BLOCKS.OL_LIST]: (_node, children) => (
                  <OrderedList
                    start={orderedListStartsAt ?? 1}
                    type={orderedListTypeMapping[orderedListTypeIndex]}
                    data-testid="legal-page-section-ol"
                  >
                    {children}
                  </OrderedList>
                )
              }}
              data={content}
            />
          </Column>
        </Layout>
      </BlockContainer>
    </div>
  );
}
